import { emailSchema } from '@common/validation/schemas';
import { fetchJson } from '@frontend/store/fetch';
import { validate } from '@frontend/utils';

const baseUrl = '/api/therapieland';

export async function isEmailDuplicateForPatient(
    emailAddress: string | null,
    patientId: string,
    signal: AbortSignal
): Promise<boolean> {
    if (!emailAddress) {
        return false;
    }

    const validatedEmail = validate({ schema: emailSchema }, emailAddress);

    if (validatedEmail.hasErrors) {
        return false;
    }

    const body = {
        emailadres: emailAddress,
        patientId,
    };

    const url = `${baseUrl}/checkIsEmailUniqueForPatient`;
    const duplicateEmail = (await fetchJson({ body, method: 'POST', signal, url })).json;

    return !duplicateEmail.isUniqueEmailForPatient;
}
